var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 106.688,
    viewBox: "0 0 186 106.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(-128 -199.91)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    x1: 173.777,
    transform: "translate(137.723 304.098)",
    fill: "none",
    stroke: "#9a9a9a",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(117 196.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7454",
    "data-name": "Path 7454",
    d: "M81.872,38.7c0,30.991-35.436,61.985-35.436,61.985S11,69.695,11,38.7a35.436,35.436,0,1,1,70.872,0Z",
    transform: "translate(0 0)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 28.686,
    cy: 28.686,
    r: 28.686,
    transform: "translate(17.75 9.566)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5535",
    "data-name": "Group 5535",
    transform: "translate(29.562 21.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7456",
    "data-name": "Path 7456",
    d: "M35.5,27.5c0,.317,0,.645-.982,1.136l-2.393,1.2V14H28.75V29.832l-2.393-1.2c-.982-.491-.982-.818-.982-1.136V14H22V27.5a4.556,4.556,0,0,0,2.847,4.154L28.134,33.3a5.062,5.062,0,0,0,.616.221V51.124h3.375V33.519a5.062,5.062,0,0,0,.616-.221l3.285-1.644A4.556,4.556,0,0,0,38.874,27.5V14H35.5Z",
    transform: "translate(-22 -14)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7457",
    "data-name": "Path 7457",
    d: "M50.874,24.125c0-5.585-3.78-10.125-8.437-10.125S34,18.539,34,24.125c0,4.894,2.9,8.981,6.75,9.92V51.124h3.375V34.045C47.974,33.105,50.874,29.018,50.874,24.125Z",
    transform: "translate(-13.751 -14)",
    fill: "#9a9a9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "walk",
    transform: "translate(111.965 211.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7461",
    "data-name": "Path 7461",
    d: "M179.354,76.835a9.153,9.153,0,0,1,5.688-1.035,4.439,4.439,0,0,1,2.068.314v-.232a9.976,9.976,0,0,1-1.394-8.3l0-.482-1.805-2.962.162-1.76a1.917,1.917,0,0,0-1.914-2.093l-1.716,0s-5.444-1.28-8.589-3.711h-.17a22.5,22.5,0,0,0-.962,5.365l-1.16,2.742a.822.822,0,0,0,.529,1.11c.468.209,1.842.161,2.082,1.452.264,1.42,1.08,4.025,3.527,4.375C178.091,71.961,179.221,74.484,179.354,76.835Z",
    transform: "translate(-18.002 -46.615)",
    fill: "#edcab0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7463",
    "data-name": "Path 7463",
    d: "M209.648,163.3s-5.628-.927-7.68,3.266c-1.815,3.71-3.6,13.417-1.97,20.728h10.281Z",
    transform: "translate(-42.607 -134.478)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7464",
    "data-name": "Path 7464",
    d: "M320.711,414.7l-2.989-1.353-4.94,6.625c0,3.658,1.666,7.269,3.726,8.533a1.832,1.832,0,0,0,2.787-1.393l2.543-10.326A1.958,1.958,0,0,0,320.711,414.7Z",
    transform: "translate(-136.063 -340.575)",
    fill: "#010300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7466",
    "data-name": "Path 7466",
    d: "M244.949,328.112a2.8,2.8,0,0,1-1.284-2.711,13.6,13.6,0,0,0-1.78-8.232l-.281.171c-.459,2.355-1.654,6.306-4.714,9.007a2.952,2.952,0,0,0-.978,2.218V332.8l11.8,7.682a2.076,2.076,0,0,0,2.868-.6l3.81-5.781Z",
    transform: "translate(-72.727 -261.33)",
    fill: "#6d8aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7468",
    "data-name": "Path 7468",
    d: "M187.887,298.961h-4.926c-2.1,5.322-4.554,8.109-4.2,13.308l1.148,16.948h9.247V313.744a3.019,3.019,0,0,1,1.017-2.253c4.576-4.077,4.951-10.954,4.951-10.954C190.119,299.342,189.454,298.961,187.887,298.961Z",
    transform: "translate(-25.61 -246.327)",
    fill: "#6d8aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7470",
    "data-name": "Path 7470",
    d: "M154.3,469.785a8.886,8.886,0,0,0-6.57,5.242,1.739,1.739,0,0,0,2.034,2.168l12.955-.063c.876-.075,1.109-.758,1.109-1.682l-.281-5.666Z",
    transform: "translate(0 -387.076)",
    fill: "#010300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7472",
    "data-name": "Path 7472",
    d: "M207.265,219.894c.1-1.553.174-5.583-1.025-8.174l-6.886.6a30.942,30.942,0,0,0,1.062,8.15,2.113,2.113,0,0,1-.273,1.8c-6.434,9.554-5.525,8.821-6.1,9.146l-2.731,1.541a1.422,1.422,0,0,0-.553,1.912h0a.951.951,0,0,1-.1,1.044,2.535,2.535,0,0,0,.827,3.809h0a3.55,3.55,0,0,0,4.625-1.227c1.867-2.9,1.95-3.158,2.6-3.649,1.468-1.108,5.956-4.828,7.683-10.056a14.148,14.148,0,0,1,.541-1.414C207.594,221.92,207.185,221.165,207.265,219.894Z",
    transform: "translate(-34.995 -174.445)",
    fill: "#edcab0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7474",
    "data-name": "Path 7474",
    d: "M264.439,172.637l-.313-3.6a4.494,4.494,0,0,0-2.9-3.806,4.612,4.612,0,0,0-1.623,3.947c.452,4.3.218,4.482.646,4.881l3.226-.281A1.056,1.056,0,0,0,264.439,172.637Z",
    transform: "translate(-92.234 -136.142)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7475",
    "data-name": "Path 7475",
    d: "M241.264,172.638a.775.775,0,0,1-.824-.722l-.354-4.063a4.323,4.323,0,0,1,1.7-3.844,4.309,4.309,0,0,0-6.157,4.232l.354,4.063a.791.791,0,0,0,.856.719l6.886-.6Z",
    transform: "translate(-72.477 -134.786)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7476",
    "data-name": "Path 7476",
    d: "M185.625,2.318s-7.655-5.808-14.429.966c-6.836,6.836,9.059,10.57,9.059,10.57l1.716,0a1.917,1.917,0,0,1,1.914,2.093,3.452,3.452,0,0,0,.247,2.432l1.579,2.592C197.475,8.319,185.625,2.318,185.625,2.318Z",
    transform: "translate(-17.997)",
    fill: "#010300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus20);
export default __webpack_public_path__ + "static/media/status-20.876c3286cb73f47435a1b1e3497e2880.svg";
export { ForwardRef as ReactComponent };